import MiniSignal from 'mini-signals';
import ApplicationDataManager from './ApplicationDataManager';

export const UnselectHotpostsiniSignal = new MiniSignal();

export default class ApplicationControl {
  static init(params) {
    return new ApplicationControl(params);
  }

  constructor(params) {
    const { application } = params;
    this.application = application;

    UnselectHotpostsiniSignal.add(() => {
      this.unselectHotposts();
    });
  }

  setData(data) {
    if (this.application) {
      this.applicationDataManager = new ApplicationDataManager({
        application: this.application,
      });

      const lang = document.querySelector('meta[name="geo.region"]');

      if (lang && lang.content.toLowerCase() === 'jp') {
        this.application.scene.root.script.app.setLocale('ja-JP');
      }

      if (lang) {
        this.application.scene.root.script.app.setRegionLocale(
          lang.content.toLowerCase()
        );
      }

      this.applicationDataManager.setData(data);
    }
  }

  runIntro() {
    if (this.application) {
      this.application.scene.root.script.app.runIntro();
    }
  }

  manualInit(hash) {
    if (this.application) {
      this.application.scene.root.script.app.manualInitialize(hash);
    }
  }

  unlockLookControls() {
    if (this.application) {
      this.application.scene.root.script.app.setLockControls(false);
    }
  }

  lockLookControls() {
    if (this.application) {
      this.application.scene.root.script.app.setLockControls(true);
    }
  }

  closeProductView() {
    if (this.application) {
      // this.unselectHotposts();
      this.application.scene.root.script.eventBridge.productUnselected();
    }
  }

  unselectHotposts() {
    if (this.application) {
      this.application.fire(
        this.application.scene.root.script.eventManager
          .ON_HOTSPOT_SET_NOT_ACTIVE_EXTERNAL
      );
    }
  }

  updateTextPlates() {
    if (this.application) {
      this.application.fire(
        this.application.scene.root.script.eventManager.ON_UPDATE_TEXT_PLATE
      );
    }
  }

  getMode() {
    let mode = '';
    if (this.application) {
      mode = this.application.scene.root.script.modeManager.getMode();
    }
    return mode;
  }

  // Main map
  openMap() {
    if (this.application) {
      this.application.scene.root.script.eventBridge.gotoOverview();
    }
  }

  // Goto overviewmap from floor
  openOverviewMap() {
    if (this.application) {
      this.application.scene.root.script.eventBridge.gotoRoomOverviewFromFloor();
    }
  }

  destroy() {
    this.application = null;
  }
}
